module.exports = __webpack_public_path__ + "static/dexus_logo-9ca55008ab4a0998c5dfd0a34c112b08.png";